/**
 * References:
 * https://codepen.io/Rjoss/pen/jxZXvP
 * Frame-by-frame video playback with GSAP: https://codepen.io/Rjoss/pen/jxZXvP
 * https://greensock.com/docs/v3/Plugins/ScrollTrigger
 */

import config from "./config";

import { gsap } from "gsap";
// import { CSSRulePlugin } from "gsap/CSSRulePlugin";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(CSSRulePlugin, ScrollToPlugin);

import { preloadSceneSprites, preloadScene4Videos } from "./preload";
import playIntro from './scenes/intro';
import initScrollTimelines from "./scroll-timelines";
import initMobile from "./landing-mobile";
import { enableScroll } from './common';

const scene1 = config["scene-1-7"];
const scene2 = config["scene-2"];
const scene3 = config["scene-3"];

ScrollTrigger.defaults({
  toggleActions: "play complete reverse reset",
  scrub: 1,
});

ScrollTrigger.addEventListener("refresh", (e) => {
  console.log("SCROLLTRIGGER REFRESHED", e);
});

let scenesLoaded = 0;
let scrollReady = false;
let scrollInitCompleted = false;

function handleScenePreloadComplete(
  scene: typeof scene1 | typeof scene2 | typeof scene3
) {
  scene.imagesLoaded = true;
  scenesLoaded++;
  console.log("handleScenePreloadComplete scenesLoaded", scene.id);
  checkInitComplete();
}

function handleScrollCalculated(){
  scrollReady = true;
  checkInitComplete();
}

/**
 * Upon scroll ready:
 * - Make content scrollable (remove 100vh + overflow:hidden lock)
 * - Hide "loading" video from device canvas
 * - Replace loading text
 * - Show scroll prompt
 */
function checkScrollReady(){
  if (scene1.imagesLoaded && scrollReady && !scrollInitCompleted) {
    window.scrollTo(0, 0);
    // document.querySelector('#starting-spacer').remove();
    document.querySelector("#scene-intro").remove();
    console.log("enableScroll?", !config.mobileLayout);
    if (!config.mobileLayout){
      enableScroll();
    }

    console.time("scroll triggers refresh");
    ScrollTrigger.refresh();
    console.timeEnd("scroll triggers refresh");
    console.log("Scroll is ready");


    const tl = gsap.timeline();
    tl.addLabel('start');
    tl.to(
      ".scene-intro-header-loading",
      {
        duration: 1,
        yPercent: -10,
        autoAlpha: 0,
      },
      "start"
    );
    tl.to(
      "#device-screen-video-wrapper",
      {
        duration: 0.2,
        autoAlpha: 0,
        onComplete: function(){
          console.log('HIDE LOADING INDICATOR VIDEO: checkScrollReady')
          const video: HTMLVideoElement = document.querySelector(
            "#device-screen-video"
          );
          gsap.set("#device-screen-video-wrapper", { visibility: "hidden" });
          try {
            video.pause();
            video.src = video.getAttribute("data-scene-1-7-src");
            console.log("UPDATE VIDEO SRC: checkScrollReady");
          } catch (e) {
            console.log("video pause error", e);
          }
        }
      },
      "start"
    );
    tl.to(
      ".scene-intro-header-after-load",
      {
        duration: 1,
        yPercent: -50,
        autoAlpha: 1,
      },
      "start+=.75"
    );
    tl.from(
      "#scroll-prompt",
      1,
      {
        duration: 1,
        yPercent: 100,
        autoAlpha: 0,
      },
      "start+=1.25"
    );

    scrollInitCompleted = true;
    return true;
  }
}

function checkInitComplete(){
  if (checkScrollReady()){
    console.timeEnd("scroll ready");
  }
  if (scenesLoaded === 3 && scrollReady){
    console.log('init complete');
    console.timeEnd('init');
    return true;
  }
  return false;
}

window.addEventListener("beforeunload", function(){
  console.log('scroll to top');
  window.scrollTo(0, 0);
});

console.time("init");
console.time("scroll ready");
preloadSceneSprites(scene1, handleScenePreloadComplete);
playIntro(() => {
  if (config.mobileLayout){
    initMobile(handleScrollCalculated);
  } else {
    initScrollTimelines(handleScrollCalculated);
  }
  preloadSceneSprites(scene2, handleScenePreloadComplete);
  preloadSceneSprites(scene3, handleScenePreloadComplete);
  preloadScene4Videos();
});
